import { Linking, Platform } from 'react-native'

/**
 * Opens an external URL in a way that preserves app navigation state.
 *
 * On web, uses `window.open` with `_blank` so the SPA tab is never replaced.
 * On native, falls back to `Linking.openURL` which launches the system browser.
 *
 * Only `http` / `https` URLs are opened via `window.open`; other schemes
 * (e.g. `mailto:`, `tel:`) always go through `Linking` so the OS can resolve
 * them to the correct handler.
 */
export async function openExternalUrl(url: string): Promise<void> {
  if (
    Platform.OS === 'web' &&
    typeof window !== 'undefined' &&
    (url.startsWith('https://') || url.startsWith('http://'))
  ) {
    window.open(url, '_blank', 'noopener,noreferrer')
    return
  }

  const supported = await Linking.canOpenURL(url)
  if (supported) {
    await Linking.openURL(url)
  }
}
